<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17n8MAR/tc-custom/9780830871155.jpg?1696025393102" alt="This image is the cover for the book Biblical Theology According to the Apostles, New Studies in Biblical Theology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Biblical Theology According to the Apostles, New Studies in Biblical Theology
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Biblical Foundations Book Awards Runner up and Finalist</strong> </p> <p> <strong>How did the apostles understand the Old Testament?</strong> </p> <p>Although relatively few in number, the New Testament's explicit summaries of the Old Testament story of Israel give readers direct access into the way the earliest Christians told this story—that is to say, into the way they did biblical theology.</p> <p>This stimulating New Studies in Biblical Theology volume examines the passages in the Synoptic Gospels, Acts, Paul's letters, and Hebrews which recount the characters, events, and institutions of Israel's story in chronological order and at substantial length. The authors demonstrate just how valuable a lens these summaries provide for a clearer vision of the earliest Christians' practice of biblical theology. In doing so, they also show how contemporary readers can and should follow the apostles' example.</p> <p>Addressing key issues in biblical theology, the works comprising New Studies in Biblical Theology are creative attempts to help Christians better understand their Bibles. The NSBT series is edited by D. A. Carson, aiming to simultaneously instruct and to edify, to interact with current scholarship and to point the way ahead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Bruno, Jared Compton, Kevin McFadden, D. A. Carson
      </h2>
      
      <p class="authorDescription body article"><p>Chris Bruno is associate dean and assistant professor of New Testament and biblical theology at Bethlehem College and Seminary in Minneapolis.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f053b1c